import React, { FC } from "react";
import { useNavigate } from "react-router-dom";

import {
  IgButton,
  IgDivider,
  IgHeaderWTooltip,
  IgPaper,
} from "@intelligems/ig-theme";
import { ExperienceDto, ExperienceListDto } from "@intelligems/ig-types";
import { Grid } from "@mui/material";

import { EXPERIMENT_ROUTES } from "../../../../routes/routes";

import { NewActiveTest } from "./NewActiveTest";

interface ActiveTestSectionProps {
  activeExperiences: ExperienceListDto[] | ExperienceDto[];
}
export const ActiveTestSection: FC<ActiveTestSectionProps> = ({
  activeExperiences,
}) => {
  const navigate = useNavigate();

  return (
    <Grid item container>
      <IgPaper
        sx={{
          boxShadow: "none",
          padding: "30px 40px 30px 40px",
          flexGrow: 1,
        }}
      >
        <Grid item container direction={"column"} rowSpacing={2}>
          <Grid
            item
            container
            direction={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
            rowSpacing={2}
          >
            <Grid item>
              <IgHeaderWTooltip
                sectionTitle={"Current Tests"}
                tooltipMessage={"Active tests are shown in this section."}
              />
            </Grid>

            <Grid item>
              <IgButton
                sx={{ width: "156px" }}
                variant={"outlined"}
                color={"secondary"}
                onClick={() => {
                  navigate(EXPERIMENT_ROUTES.Experiences);
                }}
              >
                View All Tests
              </IgButton>
            </Grid>
          </Grid>
          <IgDivider spacing={"m"} />
          <Grid container item sx={{ maxHeight: "400px", overflowY: "auto" }}>
            {activeExperiences.map((experiment, index) => (
              <NewActiveTest
                key={index}
                experience={experiment}
                isLastInList={index === activeExperiences.length - 1}
              />
            ))}
          </Grid>
        </Grid>
      </IgPaper>
    </Grid>
  );
};
